// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__L0h0c","form-title":"Common_form-title__QapiI","form-actions":"Common_form-actions__6p1+E","uploadButton":"Common_uploadButton__QnhlR"};